import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const PlantillaComentarioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [plantillas, setPlantillas] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.MOTIVONOTACREDITO).then(({ data }) =>
      setPlantillas(data)
    )
  }, [])

  return (
    <Form.Group>
      <Form.Label text='TIPO NOTA' htmlFor='select-plantillaComentario' md={3} />
      <Col md={9}>
        <Field name='tipoNota'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-plantillaComentario'
            >
              <option value=''>Seleccionar</option>
              {plantillas &&
                plantillas.map((val, key) => (
                  <option key={key} value={val._id}>
                    {val.nombre}
                  </option>
                ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlantillaComentarioFormGroup)
